import { render, staticRenderFns } from "./lang_switch.vue?vue&type=template&id=3e9eeb8c&scoped=true&"
import script from "./lang_switch.vue?vue&type=script&lang=js&"
export * from "./lang_switch.vue?vue&type=script&lang=js&"
import style0 from "./lang_switch.vue?vue&type=style&index=0&id=3e9eeb8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9eeb8c",
  null
  
)

export default component.exports